/**
 * Decide se o usuario pode usar o Assistente de IA.
 *
 * Respeita o rollout por-implementacao: quando a impl atual ja opera no
 * sistema NOVO de permissoes (``userDetails.uses_new_permissions``), o gate
 * usa o atomo granular ``ai.chat.use``; caso contrario, mantem o gate legado
 * por ``user_role``. Assim o que aparece no front acompanha exatamente o que
 * o backend enforca, sem divergencia durante a coexistencia.
 */
const LEGACY_AI_CHAT_ROLES = ["DEV", "IMG", "CAD", "CFA"];

export function canUseAIChat(userDetails) {
  if (!userDetails) return false;
  if (userDetails.uses_new_permissions) {
    return (userDetails.permissions || []).includes("ai.chat.use");
  }
  return LEGACY_AI_CHAT_ROLES.includes(userDetails.user_role);
}

export default canUseAIChat;
